import { Component } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

interface IRoleEditAfterSaveDialogResult {
    setupRoleRelations: boolean;
    shareExistingContent: boolean;
}

@Component({
    selector: 'fi-role-edit-after-save-dialog',
    templateUrl: './role-edit-after-save-dialog.component.html',
    styleUrls: ['./role-edit-after-save-dialog.component.scss'],
    standalone: false,
})
export class RoleEditAfterSaveDialogComponent extends FiDialogsContentBase<
    { hasAccessToModulesForSharing: boolean },
    IRoleEditAfterSaveDialogResult
> {
    setupRoleRelations = true;
    shareExistingContent = this.data.hasAccessToModulesForSharing;

    getResult() {
        return {
            setupRoleRelations: this.setupRoleRelations,
            shareExistingContent: this.shareExistingContent,
        };
    }
}
